import script from "./billingRecord.vue?vue&type=script&lang=ts&setup=true"
export * from "./billingRecord.vue?vue&type=script&lang=ts&setup=true"

import "./billingRecord.vue?vue&type=style&index=0&id=6d51eaca&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d51eaca"]])

export default __exports__